module.exports = __webpack_public_path__ + "img/symmetry-horizontal.b392e467.svg";